var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 869,
    height: 869,
    viewBox: "0 0 869 869",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.519 862.221C670.896 862.221 862.518 670.599 862.518 434.221C862.518 197.844 670.896 6.22211 434.519 6.22211C198.141 6.22211 6.51947 197.844 6.51947 434.221C6.51947 670.599 198.141 862.221 434.519 862.221ZM434.519 868.132C674.161 868.132 868.429 673.863 868.429 434.221C868.429 194.579 674.161 0.311035 434.519 0.311035C194.877 0.311035 0.608398 194.579 0.608398 434.221C0.608398 673.863 194.877 868.132 434.519 868.132Z",
    fill: "#D7544F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M847.296 422.411L863.399 421.952L863.45 423.738L847.347 424.197L847.296 422.411Z",
    fill: "url(#paint0_linear_499_1652)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_499_1652",
    x1: 434.519,
    y1: 0.311035,
    x2: 434.519,
    y2: 868.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondCircle);
export default __webpack_public_path__ + "static/media/second-circle.f44f6de1d4dbc9b55188a28ba8c58b41.svg";
export { ForwardRef as ReactComponent };